module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ep"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Redemption of Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Soaring through the clouds")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Arms spread, wind whisking on the back.")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Unaffected by the laws of gravity,")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("One symbol of soul and freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Disrupting the peace with a")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Crack like thunder,")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Lead whistled through the air.")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Piercing pain,")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Arms fold in,")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("The graceful glide metamorphoses")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("Into a chaotic dive.")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("The life meets the ground")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("And movement is no more.")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }, [_vm._v("But once again, Free.")]), _vm._v(" "), _c('p', {
    staticClass: "epv"
  }), _vm._v(" "), _c('p', {
    staticClass: "epvc"
  }, [_vm._v("—Jeremy Glick")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0